import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

export const excludeProductsWithoutPrice = (countryCode: CountryCodeValue) => {

  return ` and masterData(current(masterVariant(prices(country="${countryCode.toUpperCase()}"))))`;

};
